import * as React from "react";

import { CreateHealthSurveillanceCaseModal } from "../../../healthSurveillance/components/CreateHealthSurveillanceCaseModal";
import { Base as EmployeeRecords } from "../../employeeRecord";
import { TaskActionSubRoutes } from "../../../task/taskActions/TaskActionSubRoutes";
import { PpqForm } from "../../../ppq/components/PpqForm";
import { ReferralForm } from "../../../referrals/components/ReferralForm";
import { CreatePhysiotherapyReferralCaseModal } from "../../../physiotherapy/referral/components/CreatePhysiotherapyReferralCaseModal";
import { PhysiotherapyMgrReferralForm } from "../../../physiotherapy/referral/components/PhysiotherapyMgrReferralForm";
import { PhysiotherapySelfReferralForm } from "../../../physiotherapy/referral/components/PhysiotherapySelfReferralForm";
import { CreateMHPTreatmentCaseModal } from "../../../mentalHealthPractitionerTreatment/components/CreateMHPTreatmentCaseModal";

import { Detail } from "./Detail";
import { BaseItemExtensions } from "./BaseItemExtensions";
import { All } from "./All";
import { CreateImmunisationCaseModal } from "./CreateImmunisationCaseModal";
import { CreateGenericCaseModal } from "./CreateGenericCaseModal";

import { Fragment } from "redux-little-router";

const Base: React.FunctionComponent = () => {
    return (
        <div>
            <Fragment forRoute="/createPpqCase">
                <PpqForm />
            </Fragment>
            <Fragment forRoute="/createReferralCase">
                <ReferralForm />
            </Fragment>
            <Fragment forRoute="/createPhysiotherapyMgrReferralCase">
                <PhysiotherapyMgrReferralForm />
            </Fragment>
            <Fragment forRoute="/createPhysiotherapySelfReferralCase">
                <PhysiotherapySelfReferralForm />
            </Fragment>
            <Fragment forRoute="/" withConditions={l => l.params && l.params.ohCaseId === undefined}>
                <div>
                    <All />
                    <BaseItemExtensions />
                    <CreateImmunisationCaseModal />
                    <Fragment forRoute="createHealthSurveillance">
                        <CreateHealthSurveillanceCaseModal />
                    </Fragment>
                    <Fragment forRoute="createGenericCase">
                        <CreateGenericCaseModal />
                    </Fragment>
                    <Fragment forRoute="createPhysiotherapyReferralCase">
                        <CreatePhysiotherapyReferralCaseModal open={true} />
                    </Fragment>
                    <Fragment forRoute="createMHPCase">
                        <CreateMHPTreatmentCaseModal open={true} />
                    </Fragment>
                </div>
            </Fragment>
            <Fragment forRoute="/:ohCaseId/employeeRecords">
                <EmployeeRecords />
            </Fragment>
            <Fragment forRoute="/:ohCaseId">
                <>
                    <TaskActionSubRoutes />
                    <Fragment forRoute="/createPhysiotherapyMgrReferralCase/:linkedOhCaseId">
                        <PhysiotherapyMgrReferralForm />
                    </Fragment>
                    <Fragment forRoute="/createPhysiotherapySelfReferralCase/:linkedOhCaseId">
                        <PhysiotherapySelfReferralForm />
                    </Fragment>
                    <Fragment forRoute="/">
                        <Detail />
                    </Fragment>
                </>
            </Fragment>
        </div>
    );
};

export default Base;
